import { isSeededFeatureFlagOn } from '../../../helpers/seededFeatureFlags';

// Sync read of the treatment both backends seed into `<head>` (lucee and pybynder): the hybrid gate
// is decided on the first render and `useSplit` is async.
export const isHybridSearchPocSplitOn = (): boolean =>
	isSeededFeatureFlagOn('assetbank_unified_search_internal_POC');
